import Config from '../../config'
import { HTTPClient } from '@weike/toolkit'

const gwHttp = new HTTPClient({baseURL: Config.BASE_URL_ELSE}, '0000')

/**
 * 查询白名单
 * @param liveroomId
 * @param config
 * @return {AxiosPromise}
 */
export async function getWhiteList(liveroom_id) {
    const errData = { is_pgc_liverooms: false }
    try {
        const { data } = await gwHttp.get(`${Config.BASE_URL_ELSE}/v1/integration/wk_staff/outer/organization.is_in_pgc.get?org_code=${liveroom_id}&sys_name=wk_staff`)
        return data
    }catch (e) {
        return errData
    }
}



// WEBPACK FOOTER //
// ./src/api/module/gateway.js